import React, { Component } from "react";
import PropTypes from "prop-types";
import Layout from "../Layout";
import { Layout7 } from "../ContentBox";
import { DivHover, DivHelp } from "./styled";

class FlatButtonView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false
    };
  }
  onHover = () => {
    this.setState({ hover: true });
  };
  onMouseOver = () => {
    this.setState({ hover: false });
  };
  render() {
    return (
      <DivHover
        onMouseLeave={this.onMouseOver.bind(this)}
        onMouseEnter={this.onHover.bind(this)}
      >
        <Layout {...this.props} type="FlatButtonView" />
        {this.state.hover && <DivHelp>Content</DivHelp>}
      </DivHover>
    );
  }
}

FlatButtonView.propTypes = {
  childOf: PropTypes.string,
  values: PropTypes.object,
  layout: PropTypes.func
};

FlatButtonView.defaultProps = {
  childOf: "Content",
  values: {
    parent: "Content",
    type: "FlatButtonView",
    text: "FlatButton",
    containerPadding: "0px",
    fullWidth: false,
    buttonAlign: "center",
    buttonColors: {
      color: "#FFF",
      backgroundColor: "#e61919",
      hoverColor: "#42d696",
      rippleColor: "#FF9900"
    },
    border: {
      type: "solid",
      size: 0,
      color: "#e61919"
    },
    typeButton: "flat",
    labelPosition: "before",
    icon: "",
    urlSlug: {},
    href: {
      url: "",
      target: "",
      isCollection: false,
      collection: 0
    }
  },
  layout: Layout7
};
export default FlatButtonView;



// WEBPACK FOOTER //
// ./src/editor/layout/components/Content/FlatButtonView.js